// FundRevisionController
app.controller('FundRevisionController', ['$scope', 'sessionService', 'WdHttpService', '$location',
    '$timeout', 'config', 'analyticsService', '$sce', '$ocLazyLoad',
    function($scope, sessionService, WdHttpService, $location, $timeout, config, analyticsService, $sce, $ocLazyLoad) {
        $ocLazyLoad.load(config.ENACH_SDK_URL);
        // Init 
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            if (!$scope.brokerName) {
                if (!$scope.getBrokerName()) {
                    await $scope.updateBrokerPopup();
                    return;
                }
            }
            $scope.auto_approval = true;
            $scope.approve_or_reject = true;
            $scope.retry = true;
            $scope.radio_investment_type = "SIP"; // set radio button active
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            $scope.fundNametoAdviserUsernameMap = [];
            $scope.fundRevNothing = false;
            $scope.isDisabled = {};
            $scope.sipList = [];
            $scope.fundRevisions = [];
            $scope.fundRejected = [];
            $scope.pendingActions = [];
            $scope.pendingActionArray = [];
            $scope.uniquePurposeList = [];
            $scope.sortedUniquePurposeList = [];
            $scope.fundRejectedNothing = false;
            $scope.upcomingPaymentReminders = [];
            $scope.isTabActive = [true, false, false];
            $scope.pendingActionMap = new Map();
            $scope.displayNamePurposeMap = new Map();
            $scope.fee_key = "";
            if ($location.search().tab == 'payment') {
                $scope.changeTabView(1);
            }

            $scope.domain = window.location.host;
            $scope.orderedPurposeList = ['OPTIMIZERSUBSCRIPTION', 'OPTIMIZERADDLUMPSUM', 'OPTIMIZERSELLACTION', 'PENDINGREBALANCEAPPROVALS', 'REJECTEDREBALANCEAPPROVALS',
                'EQUITYSUBSCRIPTION', 'ADDITIONALSUBSCRIPTION', 'PARTIALWITHDRAWAL', 'UNSUBSCRIPTION', 'ENACHEQUITYSUBSCRIPTION', 'ENACHADDITIONALSUBSCRIPTION', 'ENACHRENEWAL'
            ];
            $scope.buttonNameMap = {
                "EQUITYSUBSCRIPTION": "Invest",
                "REJECTEDREBALANCEAPPROVALS": "Approve",
                "PENDINGREBALANCEAPPROVALS": "Approve",
                "ADDITIONALSUBSCRIPTION": "Add Lumpsum",
                "UNSUBSCRIPTION": "Complete Exit",
                "PARTIALWITHDRAWAL": "Partial Exit",
                "OPTIMIZERSUBSCRIPTION": "Subscribe",
                "OPTIMIZERADDLUMPSUM": "Buy More",
                "OPTIMIZERSELLACTION": "Sell",
                "ENACHEQUITYSUBSCRIPTION": "Retry Payment",
                "ENACHADDITIONALSUBSCRIPTION": "Retry Payment",
                "ENACHRENEWAL": "Retry Payment"
            };

            $scope.purposeDisplayNameMap = {
                "EQUITYSUBSCRIPTION": "Investment",
                "REJECTEDREBALANCEAPPROVALS": "Rejected Orders",
                "PENDINGREBALANCEAPPROVALS": "Rebalancing",
                "ADDITIONALSUBSCRIPTION": "Additonal Investment",
                "UNSUBSCRIPTION": "Exit",
                "PARTIALWITHDRAWAL": "Partial Withdrawal",
                "OPTIMIZERSELLACTION": "Sell Stocks - Recommendations",
                "OPTIMIZERSUBSCRIPTION": "Buy Stocks - Recommendations",
                "OPTIMIZERADDLUMPSUM": "Buy More - Recommendations",
                "ENACHEQUITYSUBSCRIPTION": "Retry Payment",
                "ENACHADDITIONALSUBSCRIPTION": "Retry Payment",
                "ENACHRENEWAL": "Retry Payment"
            }

            $scope.showLabel = function(action) {
                if (action.purpose == 'ADDITIONALSUBSCRIPTION' && action.investmentType == "SIP") {
                    return "Add SIP"
                } else {
                    return $scope.buttonNameMap[action.purpose]
                }
            }

            $scope.isPaymentsEnabled = config.IS_PAYMENTS_ENABLED ? config.IS_PAYMENTS_ENABLED : true;

            $('#fund-revision').addClass('active');
            await $scope.getPendingActions();
            await $scope.pendingPaymentRenewals();


        }

        $scope.changeTabView = function(tabNumber) {
            for (let i = 0; i < $scope.isTabActive.length; i++) {
                if (i == tabNumber)
                    $scope.isTabActive[i] = true;
                else
                    $scope.isTabActive[i] = false;
            }
        }

        $scope.pendingPaymentRenewals = async function() {

            await WdHttpService._get_pending_payments()
                .then(response => {
                    $scope.renewalPaymentError = undefined;
                    $scope.upcomingPaymentReminders = response;
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.renewalPaymentError = error;
                    $scope.hidePageLoader();
                })
        }

        $scope.getPendingActions = async function() {
            $scope.showPageLoader();
            await WdHttpService._get_all_pending_actions()
                .then(async function(response) {
                    if (response.status == 200) {
                        try {
                            var pendingOrders = response.data.pendingOrderIds;
                            angular.forEach(pendingOrders, function(value, key) {
                                $scope.pendingActions.push(value);
                                if ($scope.uniquePurposeList.indexOf(value.purpose) === -1) {
                                    $scope.uniquePurposeList.push(value.purpose);
                                }
                                $scope.displayNamePurposeMap.set(value.purpose, value.displayName);
                            });

                            $scope.orderedPurposeList.forEach(orderedPurpose => {
                                $scope.uniquePurposeList.forEach(uniquePurpose => {
                                    if (orderedPurpose == uniquePurpose) {
                                        $scope.sortedUniquePurposeList.push(uniquePurpose);
                                    }
                                })
                            });

                            $scope.sortedUniquePurposeList.forEach(purpose => {
                                $scope.pendingActions.forEach(pendingAction => {
                                    if (purpose == pendingAction.purpose) {
                                        $scope.pendingActionArray.push({
                                            ...pendingAction
                                        })
                                    }
                                })
                                $scope.pendingActionMap.set(purpose, $scope.pendingActionArray);
                                $scope.pendingActionArray = [];
                            });

                        } catch (error) {
                            console.log(error);
                            $scope.pending_approval_error = typeof error == 'string' ? error : "Aw Snap! something went wrong. Please try again later or reach out to us at support@wealthdesk.in or +91 8588 00 8835";
                        }
                        $scope.hidePageLoader();
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.hidePageLoader();
                    $scope.pending_approval_error = typeof error == 'string' ? error : "Aw Snap! something went wrong. Please try again later or reach out to us at support@wealthdesk.in or +91 8588 00 8835";
                    $scope.fundRevNothing = false;
                });
        };

        $scope.redirectToOrderExecution = async function(actionDetails, approvalStatus = undefined) {
            // console.log(actionDetails);
            // adviserName: "Quantech Capital"
            // adviserUsername: "quantech"
            // displayName: "Make In India"
            // fundName: "OpenQMakeInIndia"
            // orderId: "TB0SK062BU"
            // investingMode: "REAL"
            // investmentType: "LUMPSUM"
            // purpose: "OPTIMIZERSUBSCRIPTION"
            // purposeDisplayName: "Investment"
            // username: "JMFL10116241"

            if (actionDetails.purpose == 'OPTIMIZERSUBSCRIPTION') {
                $scope.showPageLoader();
                await $scope.getFundDetails(actionDetails.fundName);

                // check for risk profile and redirect if needed
                $scope.userRiskValue = await WdHttpService._get_user_risk_profile(true);
                $scope.userRiskValue = ['LOW', 'MEDIUM', 'HIGH'].includes($scope.userRiskValue) ? $scope.userRiskValue : undefined;

                if (!$scope.isAdviserResearchAnalyst && !$scope.userRiskValue && config.IS_RIA_FLOW_ENABLED) {
                    const redirectToRiskProfilePage = () => { window.location.href = '/risk-profile?next=pendingAction'; };
                    $scope.showMessagePopup("Help " + $scope.fund_details.entityManager + " understand your risk profile first and you will be redirected back to this page.", 'Complete your Risk Profile.', redirectToRiskProfilePage);
                    $scope.hidePageLoader();
                    $scope.$evalAsync();

                } else {

                    var data = {
                        fund: actionDetails.fundName,
                        adviser: actionDetails.adviserUsername
                    };
                    await WdHttpService._user_composition(data)
                        .then(async function(response) {
                            if (response.status == 200) {
                                if (response.data.isFeePaid) {
                                    $scope.advisoryFeeStatus = 'PAID';
                                } else {
                                    $scope.advisoryFeeStatus = 'NA';
                                }
                                var eventData = {
                                    'fundName': actionDetails.fundName.toLowerCase()
                                };
                                await analyticsService._push_custom_event_data_to_datalayer('pending-fund-action-' + actionDetails.purpose.toLowerCase() + "-" + actionDetails.investmentType.toLowerCase(), eventData);
                                $scope.minAmnt = response.data.minLumpSumAmount;
                                $scope.investmentAmt = parseInt(response.data.minLumpSumAmount);
                                $scope.investmentAmtOriginally = parseInt(response.data.minLumpSumAmount);
                            }
                        });

                    $scope.$broadcast("PrepareAndOpenSubscriptionUserFlow", {
                        fund_details: $scope.fund_details,
                        isAdviserResearchAnalyst: $scope.isAdviserResearchAnalyst,
                        userRiskValue: $scope.userRiskValue,
                        advisoryFeeStatus: $scope.advisoryFeeStatus,
                        minAmnt: $scope.minAmnt,
                        disallowInvestmentUserChanges: true,

                        paymentData: {
                            orderId: actionDetails.orderId,
                            investmentType: actionDetails.investmentType,
                            investmentPurpose: actionDetails.purpose,
                            investingMode: actionDetails.investingMode
                        }
                    });

                }

            } else if (actionDetails.purpose == 'OPTIMIZERADDLUMPSUM') {
                $scope.showPageLoader();
                actionDetails.investingAmount = -1;
                $scope.startRenewalPayment(actionDetails);
            } else {
                var orderId = actionDetails.orderId;
                var eventData = {
                    'fundName': actionDetails.fundName.toLowerCase()
                };
                if (approvalStatus) {
                    await analyticsService._push_custom_event_data_to_datalayer('pending-fund-action-' + actionDetails.purpose.toLowerCase() + "-" + actionDetails.investmentType.toLowerCase() + "-" + approvalStatus.toLowerCase(), eventData);
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + orderId + "&action=order-placement&approvalStatus=" + approvalStatus + "&path=" + window.location.origin;
                } else {
                    await analyticsService._push_custom_event_data_to_datalayer('pending-fund-action-' + actionDetails.purpose.toLowerCase() + "-" + actionDetails.investmentType.toLowerCase(), eventData);
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + orderId + "&action=order-placement&path=" + window.location.origin;
                }
            }

        }

        $scope.confirmRejection = function(data) {
            $scope.tempRejectedOrders = data;
            $('#confirm_rejection_modal').modal('show');
        }

        $scope.trustAction = function() {
            return $sce.trustAsResourceUrl(config.PAYTM_URL);
        };

        /**
         * data input consist of 
         * adviserName: "Akash Agarwal"
         * adviserUsername: "quantech"
         * displayName: "Inida Distributor ka Fund"
         * expiryDate: 1631872800000
         * fundName: "OpenQMakeInIndia"
         * investmentAmount: 10000
         * investmentType: "LUMPSUM"
         * purpose: "ENACHEQUITYSUBSCRIPTION"
         * @param {*} data 
         */
        $scope.startRenewalPayment = async function(data) {
            $scope.showPageLoader();

            $scope.addMoreFundName = data.fundName;
            $scope.addMoreFundMode = 'REAL';
            $scope.addMoreAdviserUsername = data.adviserUsername
            $scope.buyMoreError = false;
            $scope.buyMoreConfirmError = false;
            $scope.buyMoreFund = true;
            $scope.congratsData = false;

            $scope.isEnachEnabled = $scope.isAdviserPropertyEnabled(data.adviserUsername, 'eNachEnabled');

            $scope.isPaytmDisabled = $scope.isAdviserPropertyEnabled(data.adviserUsername, 'paytmDisabled');
            $scope.payment_type = $scope.isEnachEnabled ? "enach" : "paytm"; // select the default option for the user
            $scope.investmentType = data.investmentType;
            await $scope.getFundDetails(data.fundName);
            $scope.paymentRenewalData = data;

            if (data.investmentType == 'SIP' && data.purpose == 'ADDITIONALSUBSCRIPTION') {
                $scope.investmentAmt = parseInt(data.investmentAmount);
                $scope.addMorePaymentModal = true;
                $scope.paymentDetailModal = false;
            } else {
                $scope.showPageLoader();
                await $scope.addMoreFeePaymentSubmit(data);
            }
            $('#paymentModal').modal('show');

            var eventData = {
                'fundName': $scope.fundName.toLowerCase()
            };
            await analyticsService._push_custom_event_data_to_datalayer(data.investmentType.toLowerCase() + '-fee-payment-modal-opened-' + data.purpose.toLowerCase(), eventData);
            $scope.hidePageLoader();
        }

        $scope.addMoreFeePaymentSubmit = async function(data) {
            var investingAmount;
            if (data.investmentType == 'SIP' && data.purpose == 'ADDITIONALSUBSCRIPTION') {
                investingAmount = parseInt($("#totalInvAmountForFee").val().replace(/,/g, ''));
            } else {
                investingAmount = data.investmentAmount;
            }

            $scope.investingPurpose = data.purpose;
            $scope.investmentAmt = investingAmount;
            $scope.fundName = data.fundName;

            await $scope.submitInvestingAmount(investingAmount, data.investmentType, data.fundName, data.adviserUsername, data.purpose, 0);
        }

        $scope.submitInvestingAmount = async function(amount, investmentType = 'LUMPSUM',
            fundName, adviserUsername, investmentPurpose, sipDay) {

            investmentType = investmentType.toUpperCase();
            $scope.showLoading('#confirmInvestmentAmount');
            await WdHttpService._get_dynamodb_user_profile().then(async response => {
                $scope.isMandateRegistered = false;
                if ("advisortoMandateDetails" in response) {
                    if (adviserUsername in response.advisortoMandateDetails) {
                        $scope.isMandateRegistered = true;
                    }
                }
            })

            $scope.paymentDetails = {};
            $scope.paymentDetails.investingPurpose = $scope.investingPurpose;
            $scope.paymentDetails.investmentType = investmentType;
            $scope.paymentDetails.sipDay = sipDay;
            if (investmentType == 'SIP' && investmentPurpose == 'ADDITIONALSUBSCRIPTION') {
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.investmentSipAmtOriginally);
            } else {
                $scope.minimumAmountForAdvisoryPayment = 0; //parseInt($scope.fund_details.minAmount);
            }

            var validateMoreThanMinLumpsum = amount >= $scope.minimumAmountForAdvisoryPayment;
            if ($scope.fund_details && validateMoreThanMinLumpsum) {
                $scope.paymentDetails.investmentAmt = amount;
                $scope.distributorId = $scope.isAdviser ? $scope.fund_details.adviserUsername : sessionService.get("distributorName");
                await WdHttpService._get_user_advisory_fee_amount(
                    $scope.fundName,
                    $scope.fund_details.adviserUsername,
                    $scope.distributorId,
                    $scope.paymentDetails.investmentAmt,
                    $scope.investingPurpose,
                    $scope.investingMode,
                    $scope.paymentDetails.investmentType
                ).then(async response => {
                    // if response.data.feeAmount is Zero then call is_fee_paid
                    $scope.paymentDetails.fee_key = response.data.key;
                    $scope.paymentDetails.feeAmount = response.data.feeAmount;
                    if ($scope.paymentDetails.feeAmount == 0 && $scope.investingPurpose != 'RENEWAL') {
                        var data = {
                            purpose: $scope.investingPurpose,
                            investingMode: $scope.investingMode,
                            investmentAmount: $scope.paymentDetails.investmentAmt,
                            investmentType: $scope.paymentDetails.investmentType,
                            fundName: $scope.fundName,
                            adviserUsername: $scope.fund_details.adviserUsername,
                            sipDay: $scope.paymentDetails.sipDay ? $scope.paymentDetails.sipDay : 0
                        }
                        WdHttpService._is_fee_paid(data)
                            .then(async response => {
                                var eventData = {
                                    'fundName': $scope.fundName.toLowerCase()
                                };                    
                                await analyticsService._push_custom_event_data_to_datalayer('fee-zero-' + $scope.investingPurpose.toLowerCase() + "-" + $scope.paymentDetails.investmentType.toLowerCase(), eventData);
                                if (config[$scope.brokerName]) {
                                    $scope.$evalAsync();
                                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + response.data.orderId + "&action=order-placement&path=http://" + window.location.hostname + ':' + window.location.port;
                                } else {
                                    // considering its a offline broker
                                    window.location.href = '/order-placement' + "?orderId=" + response.data.orderId + "&action=order-placement&path=http://" + window.location.hostname + ':' + window.location.port;
                                }
                            }).catch(error => {
                                $scope.showErrorPopup(error);
                                $scope.$evalAsync();
                                $scope.hidePageLoader();
                            });
                    } else if (response.data.feeAmount == 0 && investmentPurpose == 'RENEWAL') {
                        $scope.showErrorPopup('Incorrect State and Fee Amount combination, Sorry cannot proceed');
                        var eventData = {
                            'fundName': $scope.fundName.toLowerCase()
                        };
                        await analyticsService._push_custom_event_data_to_datalayer('state-and-fee-amount-combination-error-' + $scope.investingPurpose.toLowerCase() + "-" + response.data.feeAmount, eventData);

                        return;
                    } else {
                        // display the payment display in UI 
                        $scope.paymentDetails.gstAmt = ($scope.paymentDetails.feeAmount * .18).toFixed(2);
                        $scope.paymentDetails.payment_charges = 0;
                        $scope.paymentDetails.totalAmt = parseFloat($scope.paymentDetails.feeAmount) + parseFloat($scope.paymentDetails.gstAmt) + parseFloat($scope.paymentDetails.payment_charges);
                        $scope.paymentDetails.totalAmt = $scope.paymentDetails.totalAmt.toFixed(2);
                        var eventData = {
                            'fundName': $scope.fundName.toLowerCase()
                        };
                        await analyticsService._push_custom_event_data_to_datalayer('fee-details-displayed-' + $scope.investingPurpose.toLowerCase() + "-" + $scope.paymentDetails.investmentType.toLowerCase(), eventData);
                        $scope.addMorePaymentModal = false;
                        $scope.paymentDetailModal = true;
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.hidePageLoader();
                    if (investmentType.toUpperCase() != 'SIP') {
                        $scope.showErrorPopup(error);
                    } else {
                        $scope.showErrorMessageInSubscribeForm(error);
                    }
                });
            } else if (!validateMoreThanMinLumpsum) {
                $scope.showErrorPopup("Sorry, you have entered an amount less than the minimum required amount to invest, i.e. " + $scope.minimumAmountForAdvisoryPayment);
            }
            $scope.stopLoading('#confirmInvestmentAmount');
        }

        $scope.selectPayment = async function(paymentGateway) {
            if (!$scope.paymentDetails || !$scope.fund_details || !$scope.distributorId) {
                if (!$scope.paymentDetails)
                    $scope.showErrorPopup('Payment Details are incomplete, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                if (!$scope.fund_details)
                    $scope.showErrorPopup('WealthBasket Details not found, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                if (!$scope.distributorId)
                    $scope.showErrorPopup('Identifier is missing, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                return;
            }
            $scope.showLoading('#btnPaymentSubmit');
            if (paymentGateway == 'paytm') {
                $scope.createPaytmOrder($scope.paymentDetails, $scope.fund_details, $scope.distributorId)
            } else if (paymentGateway == 'enach') {
                if ($scope.isMandateRegistered) {
                    $scope.executeExistingMandate($scope.paymentDetails, $scope.fund_details);
                } else {
                    $scope.registerENachFlow($scope.paymentDetails, $scope.fund_details, $scope.distributorId)
                }
            }
        }

        //register mandate & open the popup or 
        $scope.registerENachFlow = async function(paymentDetails, fund_details, distributorId) {

            $scope.showPageLoader();
            var deploymentDetails = await WdHttpService._get_deployment_details(await WdHttpService._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
            const brokerBasedApiUrl = deploymentDetails.apiUrl;
            $scope.enach_data_request = {
                "adviserUsername": fund_details.adviserUsername,
                "distributor_id": distributorId,
                "fee_amount": paymentDetails.feeAmount,
                "fundName": fund_details.fundName,
                "gst_amount": paymentDetails.gstAmt,
                "investment_amount": paymentDetails.investmentAmt,
                "investment_type": paymentDetails.investmentType,
                "key": paymentDetails.fee_key,
                "period": fund_details.feePeriod,
                "purpose": paymentDetails.investingPurpose,
                "sipDay": paymentDetails.sipDay ? $scope.sipDay : 0,
                "callback_url": brokerBasedApiUrl,
                "caller_domain": location.host
            };
            await WdHttpService._post_mandate_registration($scope.enach_data_request)
                .then(response => {
                    let mandateData = response;
                    if (navigator.userAgent.includes('wv')) { //android webview check 
                        mandateData.features.enableNewWindowFlow = false;
                    }
                    $.pnCheckout(mandateData);
                    if (mandateData.features.enableNewWindowFlow) {
                        pnCheckoutShared.openNewWindow();
                    }
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                });
            $scope.stopLoading('#btnPaymentSubmit');
        }

        $scope.showErrorMessagePayment = function(message) {
            $scope.errorMessage = true;
            $scope.confirmErrorMessage = message;
            $timeout(function() {
                $scope.errorMessage = false;
            }, 5000);
        }

        //mandate check if status completed
        $scope.executeExistingMandate = async function(paymentDetails, fund_details) {
            $scope.showPageLoader();
            $scope.data_request = {
                "fundName": fund_details.fundName,
                "adviserUsername": fund_details.adviserUsername,
                "investingMode": $scope.investingMode,
                "distributorUsername": $scope.distributorUsername ? $scope.distributorUsername : fund_details.adviserUsername,
                "investingPurpose": paymentDetails.investingPurpose,
                "investment_type": paymentDetails.investmentType,
                "investment_amount": paymentDetails.investmentAmt,
                "sipDay": paymentDetails.sipDay ? $scope.sipDay : 0,
                "fee_amount": paymentDetails.feeAmount,
                "gst_amount": paymentDetails.gstAmt,
                "key": paymentDetails.fee_key
            };
            await WdHttpService._post_existing_mandate($scope.data_request)
                .then(response => {
                    let mandateOrderId = response.orderId;
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + mandateOrderId + "&action=order-placement&path=" + window.location.href;
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                });
            $scope.stopLoading('#btnPaymentSubmit');
        }

        $scope.createPaytmOrder = async function(paymentDetails, fund_details, distributorId) {
            $scope.showPageLoader();
            var deploymentDetails = await WdHttpService._get_deployment_details(await WdHttpService._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
            const brokerBasedApiUrl = deploymentDetails.apiUrl + '/investor/';
            $scope.paytm_data_request = {
                TXN_AMOUNT: paymentDetails.totalAmt,
                FEE_AMOUNT: paymentDetails.feeAmount,
                GST_AMOUNT: paymentDetails.gstAmt,
                PAYMENT_CHARGES: paymentDetails.payment_charges,
                CALLBACK_URL: brokerBasedApiUrl + config.CALLBACK_URL,
                CALLER_DOMAIN: location.host,
                CHANNEL_ID: config.CHANNEL_ID,
                INDUSTRY_TYPE_ID: config.INDUSTRY_TYPE_ID,
                WEBSITE: config.WEBSITE,
                FUND_NAME: fund_details.fundName,
                ADVISER_USERNAME: fund_details.adviserUsername,
                "investment_amount": paymentDetails.investmentAmt,
                "purpose": paymentDetails.investingPurpose,
                "investment_type": paymentDetails.investmentType,
                "sipDay": paymentDetails.sipDay ? $scope.sipDay : 0,
                "key": paymentDetails.fee_key,
                "distributor_id": distributorId
            };
            await WdHttpService._create_order_checksum($scope.paytm_data_request)
                .then(response => {
                    $scope.paytm_data = response.data;
                    $scope.addMorePaymentModal = false;
                    $scope.paymentDetailModal = true;
                    $scope.$evalAsync();
                    submitForm($scope);
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                });
            $scope.stopLoading('#btnPaymentSubmit');
        }

        function submitForm($scope, recursion = true) {
            setTimeout(() => {
                if (document.getElementById("btnPaytmSubmit")) {
                    document.getElementById("btnPaytmSubmit").click();
                } else {
                    if (recursion) {
                        submitForm($scope, false);
                    } else {
                        $scope.showErrorPopup("Sorry, we are not able to submit the details. Please try again or contact support.");
                    }
                }
            }, 1000);
        }

        $scope.getFundDetails = async function(fundName) {
            var data = {
                q: "fundName:" + fundName,
                f: "web_admin:" + $scope.webadminName
            };
            await WdHttpService._get_funds(data)
                .then(async function(response) {
                    if (response.status == 200) {
                        var fund_details;
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == fundName)
                                    fund_details = fund;
                            });
                        } else
                            fund_details = response.data.Items[0];

                        $scope.isAdviserResearchAnalyst = fund_details.wealthBasketType == 'RA' ? true : false;
                        $scope.fundIcon = fund_details.fundIcon;
                        $scope.displayName = fund_details.displayName;
                        $scope.fund_details = fund_details;

                        if ($scope.fund_details.childFund != undefined) {
                            if ($scope.fund_details.childFund.length > 0) {
                                $scope.investmentSipAmt = parseInt($scope.fund_details.childFund[0].minAmount);
                                $scope.investmentSipAmtOriginally = parseInt($scope.fund_details.childFund[0].minAmount);
                                for (var i = 0; i < $scope.fund_details.childFund.length; i++) {
                                    if ($scope.fund_details.childFund[i].minAmount < $scope.investmentSipAmt) {
                                        $scope.investmentSipAmt = parseInt($scope.fund_details.childFund[i].minAmount);
                                        $scope.investmentSipAmtOriginally = parseInt($scope.fund_details.childFund[i].minAmount);
                                    }
                                }
                            }
                        }

                        if (fund_details.minAdditionalLumpsum) {
                            $scope.investmentAmt = parseInt(fund_details.minAdditionalLumpsum);
                            $scope.investmentAmtOriginally = parseInt(fund_details.minAdditionalLumpsum);
                        } else {
                            $scope.investmentAmt = parseInt(fund_details.minAmount);
                            $scope.investmentAmtOriginally = parseInt(fund_details.minAmount);
                        }
                    }
                }).catch(error => {
                    console.error(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.downloadCSVConverter = async function(orderId, filename) {
            $scope.showPageLoader();
            var data = [];
            var param = {
                orderId: orderId,
                brokerAuthentication: {
                    "sessionId": sessionService.get("brokerName"),
                    "transactionId": JSON.stringify({
                        "groupId": "",
                        "sessionId": "",
                        "transactionId": ""
                    })
                }
            };
            await WdHttpService._get_stock_splits(param).then(response => {
                var stockData = response.data;
                for (const key in stockData.subscriptionSharesDetails) {
                    var stockDetails;
                    if (stockData.subscriptionSharesDetails.hasOwnProperty(key)) {
                        stockDetails = stockData.subscriptionSharesDetails[key];
                    }
                    data.push({
                        "share": key,
                        "adviseType": stockDetails.adviseType,
                        "currentMarketValue": stockDetails.currentMarketValue,
                        "exchange": stockDetails.exchange,
                        "price": stockDetails.price,
                        "sharesQuantity": stockDetails.sharesQuantity
                    });
                }
                $scope.downloadStockList(data, filename);
                $scope.hidePageLoader();
            }).catch(err => {
                $scope.hidePageLoader();
                console.log(err);
                $scope.showErrorPopup('CSV download was unsucessfull');
            })
        }

        $scope.showErrorMessageInSubscribeForm = function(message) {
            $scope.subStatus = true;
            $scope.subcritionErrorMsg = message;
            $timeout(function() {
                $scope.subStatus = false;
            }, 5000);
        }

    }
]);